import { images } from "assets";
import { Header } from "Components/header/Header";
import Text from "Components/shared/text";
import { EmptyComponent } from "Components/shared/transactions";
import React, { startTransition, useEffect, useState } from "react";
import styles from "./debit.module.css";
import { useNavigate } from "react-router-dom";
import { DebitCardHomeContent } from "./DebitCardHomeContent";
import DebitCardHomeBody from "./DebitCardHomeBody";
import {
  requestNewCard,
  useGetUsersDebitCard,
} from "services/debitCardService";
import { Storage } from "utils/clientStorage";
import { RequestNewCardModal } from "./RequestNewCardModal";
import { SuccessModal } from "Components/shared/successful/SuccessModal";
import { ErrorModal } from "Components/shared/successful/ErrorModal";

const DebitHead = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ marginBottom: "22px" }} className={styles.tip}>
        <Text variant="xl" style={{ fontWeight: 600 }}>
          Debit Card
        </Text>
        <Text color="secondary" variant="sm">
          View your debit card and transactions
        </Text>
      </div>
      <Header hidden />
    </div>
  );
};

const EmptyPage = ({ handleNewCard }) => {
  let navigate = useNavigate();

  return (
    <div className={styles.empty}>
      <EmptyComponent
        graphics={<img src={images.debit} alt="empty transactions" />}
        title="Opps! Looks like you do not have a debit card"
        description="You don’t have any card just yet. request for a card and start making tranactions."
        action={{
          label: "Go to wallet",
          onClick: handleNewCard,
          // onClick: () => startTransition(() => navigate("request-debit-card")),
          fullWidth: true,
        }}
      />
    </div>
  );
};

const DebitCardHome = () => {
  const [data, setData] = useState(null);
  const [newCardState, setNewCardState] = useState(false);
  const [deactivateCardState, setDeactivateCardState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = React.useState(false);
  const [errorModal, setErrorModal] = React.useState(false);
  const [errMessage, setErrMessage] = React.useState(null);

  useEffect(() => {
    const data = Storage.getItem("DEBITCARD");
    console.log("DATA ", data);

    setData(data);
  }, []);

  const handleNewCard = () => {
    setNewCardState(true);
  };

  const func = () => {
    setConfirmModal(false);
    setNewCardState(false);
    // setVisible(false);
  };

  const requestCard = async () => {
    setLoading(true);
    try {
      const data = await requestNewCard("usd");
      console.log("DATA RETURNED ", data);
      setConfirmModal(true);
      setLoading(false);
    } catch (err) {
      setErrorModal(true);
      setLoading(false);
      setErrMessage(err.message);
      console.log(err);
    }
  };

  console.log("DATA ", data);

  return (
    <>
      <div className={styles.root}>
        <DebitHead />
        {!data && <EmptyPage handleNewCard={handleNewCard} />}
        <DebitCardHomeContent />
        <DebitCardHomeBody />
      </div>
      <RequestNewCardModal
        openModal={newCardState}
        setOpenModal={setNewCardState}
        requestCard={requestCard}
        loading={loading}
      />
      <SuccessModal openModal={confirmModal} func={func} />
      <ErrorModal
        message={errMessage}
        openModal={errorModal}
        setErrorModal={setErrorModal}
      />
    </>
  );
};

export default DebitCardHome;
